const layout = {
  modalZIndex: 11,
}

export default layout
